export const isServerSideRendering = (function serverSideRenderCheck() {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
})();

export function safeParse<T = any>(input: string): T | undefined {
  try {
    return JSON.parse(input);
  } catch (ex) {
    return undefined;
  }
}

export function toError(err: unknown): Error {
  return err instanceof Error ? err : new Error(String(err));
}
